<template>
  <GridBase gak-common class="gak-sejong">
    <section class="top">
      <h1>GAK<br />SEJONG</h1>
    </section>
    <section class="s1 j">
      <PrSplit class="v1" type="type0" img="/img/dc/sejong/bg-hyperscale.png">
        <div class="title">
          <h2><i>우리 모두의</i></h2>
          <h2><i>테크 컨버전스</i> <i>엔진</i></h2>
        </div>
      </PrSplit>
      <TextBlock file="dc/sejong-data-t1" class="pre-line q j" data-offset="100" />
    </section>
    <section class="s2 j" data-offset="0">
      <PrHoldOrNot img="/img/dc/sejong/bg-map.jpg" title="Location" direction="" mobile-height="375">
        <template v-slot:holdRight>
          <div class="dc-sample-s2-exp" data-p="0.4,1" data-px="-100,0" data-a="0,1">
            <h3>이곳은 <br />세종특별시</h3>
            <div class="cover">
              <h4>
                중단 없는<br />
                데이터센터를 위한<br />
                최적의 부지
              </h4>
              <h5>
                데이터센터 각 세종은 안정적인 전력 공급과 통신망 확보를 우선적으로 고려해 설계되었습니다. 10여 개의
                후보지를 면밀히 검토한 결과, 안정적으로 데이터센터를 운영할 수 있는 조건을 갖춘 세종시를 최종 부지로
                확정하였습니다. 해당 부지는 154kV 변전소로부터 최대 270MW의 전력을 2회선으로 공급받을 수 있습니다.
              </h5>
            </div>
          </div>
        </template>

        <div class="dc-sample-s2-exp">
          <div class="img">Location</div>
          <h3 class="q">이곳은 <br class="hidden-md-up" />세종특별시</h3>
          <div class="cover">
            <h4>
              중단 없는<br />
              데이터센터를 위한<br />
              최적의 부지
            </h4>
            <p class="q">
              데이터센터 각 세종은 안정적인 전력 공급과 통신망 확보를 우선적으로 고려해 설계되었습니다. 10여 개의
              후보지를 면밀히 검토한 결과, 안정적으로 데이터센터를 운영할 수 있는 조건을 갖춘 세종시를 최종 부지로
              확정하였습니다. 해당 부지는 154kV 변전소로부터 최대 270MW의 전력을 2회선으로 공급받을 수 있습니다.
            </p>
          </div>
        </div>
      </PrHoldOrNot>
    </section>
    <section class="s3 energy">
      <PrBlock class="v1 j">
        <img src="/img/dc/sejong/bg-s3.jpg" alt="" />
      </PrBlock>
      <div class="exp">
        <h4>
          <TextBlock file="dc/sejong-data-t3" class="pre-line q" />
        </h4>
        <TextBlock file="dc/sejong-data-t2" class="q" />
      </div>
    </section>
    <section class="s3 arc">
      <GridBase class="c1" v-if="this.sect === 'sm' || this.sect === 'md'">
        <div class="img">
          <div class="bg"></div>
          <div class="tit">
            <h3>
              <em>ARC & ARM-System</em>
              클라우드 기반 로봇 운영 시스템
            </h3>
          </div>
        </div>
        <div class="exp">
          <TextBlock file="dc/sejong-data-t4" class="pre-line q" />
        </div>
      </GridBase>
      <PrSlideOrNot
        id="arc-v1"
        img="/img/dc/sejong/bg-arc.jpg"
        title="ARC & ARM-System"
        titleSub="클라우드 기반 로봇 운영 시스템"
        direction="l2r"
        v-else
        class="j"
        data-offset="0"
      >
        <template v-slot:slide>
          <TextBlock data-p="0.8,1" data-a="0,1" data-y="50,0" file="dc/sejong-data-t4" class="pre-line" />
        </template>
      </PrSlideOrNot>
    </section>
    <section class="s3 robot">
      <ul>
        <li>
          <PrBlock class="v1 j">
            <slider>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong/sero-slide-1_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong/sero-slide-1_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong/sero-slide-1_md.png" />
                <img src="/img/dc/sejong/sero-slide-1.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong/sero-slide-2_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong/sero-slide-2_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong/sero-slide-2_md.png" />
                <img src="/img/dc/sejong/sero-slide-2.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong/sero-slide-3_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong/sero-slide-3_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong/sero-slide-3_md.png" />
                <img src="/img/dc/sejong/sero-slide-3.png" alt="" />
              </picture>
            </slider>
          </PrBlock>
          <div class="exp">
            <h4>
              <em>세로(SeRo),</em>
              자산관리 자동화 로봇
            </h4>
            <TextBlock file="dc/sejong-data-t6-1" class="txt" />
          </div>
        </li>
        <li class="small">
          <PrBlock class="v1 j">
            <slider>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//garo-slide-1_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//garo-slide-1_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//garo-slide-1_md.png" />
                <img src="/img/dc/sejong/garo-slide-1.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//garo-slide-2_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//garo-slide-2_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//garo-slide-2_md.png" />
                <img src="/img/dc/sejong/garo-slide-2.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//garo-slide-3_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//garo-slide-3_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//garo-slide-3_md.png" />
                <img src="/img/dc/sejong/garo-slide-3.png" alt="" />
              </picture>
            </slider>
          </PrBlock>
          <div class="exp">
            <h4>
              <em>가로(GaRo),</em>
              자율운송 로봇
            </h4>
            <TextBlock file="dc/sejong-data-t6-2" class="txt" />
          </div>
        </li>
        <li class="small">
          <PrBlock class="v1 j">
            <picture>
              <source media="(min-width: 1600px)" srcset="/img/dc/sejong//robostation-slide-1_pc.png" />
              <source media="(min-width: 1024px)" srcset="/img/dc/sejong//robostation-slide-1_lg.png" />
              <source media="(min-width: 768px)" srcset="/img/dc/sejong//robostation-slide-1_md.png" />
              <img src="/img/dc/sejong/robostation-slide-1.png" alt="" />
            </picture>
          </PrBlock>
          <div class="exp">
            <h4>
              <em>로보스테이션</em>
              (ROBOSTATION)
            </h4>
            <TextBlock file="dc/sejong-data-t6-3" class="txt" />
          </div>
        </li>
        <li>
          <PrBlock class="v1 j">
            <slider>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//alt-b-slide-1_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//alt-b-slide-1_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//alt-b-slide-1_md.png" />
                <img src="/img/dc/sejong/alt-b-slide-1.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//alt-b-slide-2_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//alt-b-slide-2_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//alt-b-slide-2_md.png" />
                <img src="/img/dc/sejong/alt-b-slide-2.png" alt="" />
              </picture>
            </slider>
          </PrBlock>
          <div class="exp">
            <h4>
              <em>알트비(ALT-B),</em>
              자율주행 셔틀
            </h4>
            <TextBlock file="dc/sejong-data-t6-4" class="txt" />
          </div>
        </li>
      </ul>
    </section>
    <section class="s6 technology">
      <PrSplit class="v1 q" type="type1" img="/img/dc/sejong/bg-technology.jpg" title="Technology" />
      <div class="exp">
        <h4 class="q">첨단 기술의 <br />집약체</h4>
        <p class="q">
          데이터센터 각 세종은 초대규모 AI, 클라우드 서비스, 디지털 트윈, 로봇 등 각종 네이버 미래 서비스와 기술을
          안정적으로 운영할 수 있는 하이퍼스케일 데이터센터로서 새로운 시대를 열어갑니다.
        </p>
      </div>
      <quick-link-item type="gray">
        <a class="" href="/tech/technology">Technology에서 <br />확인하기</a>
      </quick-link-item>
    </section>
    <section class="s4 architecture">
      <PrSplit class="v4" img="/img/dc/sejong/bg-architecture.jpg" title="Architecture" />

      <div class="exp">
        <h3>
          기술과 자연의<br />
          공존을 위한 설계
        </h3>
        <video :src="`${videoBase}/sejong.mp4`" muted autoplay loop playsinline class="pic" />
        <h4 class="q">
          자연 바람과<br />
          맞닿은 서버실
        </h4>
        <p class="q">
          데이터센터 각 세종은 자연의 흐름을 방해하지 않으며 에너지 효율을 극대화 할 수 있는 최적의 배치와 형태로
          설계되었습니다.
        </p>
      </div>
    </section>
    <section class="s5 building">
      <PrHoldOrNot
        id="building-v1"
        img="/img/dc/sejong/bg-building.jpg"
        :html="buildingT1"
        text="데이터센터 각 세종은 환경 훼손을 줄이기 위해, 인위적인 가공을 최소화하는 공법이 적용된 건축 자재와 재료로 지어졌습니다. 콘크리트를 그대로 노출하고, 인위적인 가공을 하지 않는 친환경 알루미늄을 주재료로 적용하는 등 친환경 재료를 적극적으로 활용하여 건축했습니다."
        direction="b2t"
        position="right"
        mobile-height="375"
      >
        <template v-slot:holdBottom>
          <div id="building-t2" class="dc-sample-s2-exp" data-p="0.4,1" data-a="0,1" data-py="50,0">
            <div class="cover">
              <h3 class="q">하나의 랙(Rack)에서부터 <br />거대한 서버관까지</h3>
              <p class="q">
                급격한 기술 성장과 서비스 변화로 늘어나는<br />
                방대한 양의 데이터를 랙과 존, 서버관으로 유연하게 확장,<br />
                운영할 수 있는 구조를 가지고 있습니다.
              </p>
            </div>
          </div>
        </template>
        <div class="dc-sample-s2-exp">
          <div class="img">
            <div class="exp">
              <h3 class="q">자연과 <br class="hidden-sm-down" />닮은 건물</h3>
              <p class="q">
                데이터센터 각 세종은 건물이 자연의 일부로 녹아든 것처럼 보여지도록 자재 그대로의 매력을 살렸습니다. 별도
                가공이 필요 없는 콘크리트, 코팅과 페인트칠을 하지 않은 친환경 알루미늄을 사용하여 환경 파괴 또한
                최소화했습니다.
              </p>
            </div>
          </div>
          <div class="cover">
            <h3 class="q">하나의 <br class="hidden-md-up" />랙(Rack)에서부터 <br />거대한 서버관까지</h3>
            <p class="q">
              급격한 기술 성장과 서비스 변화로 늘어나는 방대한 양의 데이터를 랙과 존, 서버관으로 유연하게 확장, 운영할
              수 있는 구조를 가지고 있습니다.
            </p>
          </div>
        </div>
      </PrHoldOrNot>
    </section>
    <section class="s5 main-building">
      <PrSplit class="v5" type="type2" img="/img/dc/sejong/bg-main-building.jpg" />
      <div class="exp">
        <h4 class="q">기본에<br class="hidden-xl-down" />충실한 본관</h4>
        <TextBlock file="dc/sejong-data-t7" class="q pre-line" />
      </div>
    </section>
    <div class="feature j">
      <section class="s4 gallery">
        <PrSplit class="v4" img="/img/dc/sejong/bg-gallery.png" title="GAK SEJONG Gallery" overflowTitle="" />
      </section>
      <SliderTumbs navigation="true"
        ><div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-23.png" />
          </div>
          <div class="txt">
            <p>축구장 41개 크기의 부지에 지어진 네이버의 두 번째 자체 데이터센터 각 세종</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-22.png" />
          </div>
          <div class="txt">
            <p>축구장 41개 크기의 부지에 지어진 네이버의 두 번째 자체 데이터센터 각 세종</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-1.png" />
          </div>
          <div class="txt">
            <p>축구장 41개 크기의 부지에 지어진 네이버의 두 번째 자체 데이터센터 각 세종</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-24.png" />
          </div>
          <div class="txt">
            <p>주출입구에서 본관(운영동), 북관(서버관)으로 이어지는 각 세종의 전경</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-2.png" />
          </div>
          <div class="txt">
            <p>서비스 규모에 맞춰 단계적 확장이 가능한 구조로 구축된 서버관(북관)</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-25.png" />
          </div>
          <div class="txt">
            <p>서비스 규모에 맞춰 단계적 확장이 가능한 구조로 구축된 서버관(북관)</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-26.png" />
          </div>
          <div class="txt">
            <p>서비스 규모에 맞춰 단계적 확장이 가능한 구조로 구축된 서버관(북관)과 브릿지로 연결된 본관</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-3.jpg" />
          </div>
          <div class="txt">
            <p>빛 반사를 최소화시킬 수 있는 굴곡진 형태로 냉방 효율성을 높이기 위해 설치된 알루미늄 패널</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-4.png" />
          </div>
          <div class="txt">
            <p>각 세종의 운영 업무 관련 공간들이 위치한 본관</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-5.jpg" />
          </div>
          <div class="txt">
            <p>이슈 발생 시 빠르게 대응할 수 있도록 본관과 서버관(북관)을 연결하는 브릿지</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-6.jpg" />
          </div>
          <div class="txt">
            <p>근무자들의 안전하고 편안한 이동을 돕는 무인 자율주행 셔틀 ALT-B</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-7.jpg" />
          </div>
          <div class="txt">
            <p>효율적인 데이터센터 운영을 위해 로봇 자동화 시스템을 적용한 IT로봇 창고</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-8.jpg" />
          </div>
          <div class="txt">
            <p>업무 효율을 높이는 자산 관리 자동화 로봇 세로(SeRo)</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-9.jpg" />
          </div>
          <div class="txt">
            <p>고중량 장비도 거뜬히 옮기는 자율운송 로봇 가로(GaRo)</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-10.jpg" />
          </div>
          <div class="txt">
            <p>데이터센터의 모든 상황을 한 눈에 파악하고 대응할 수 있는 관제센터</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-11.jpg" />
          </div>
          <div class="txt">
            <p>고성능 서비스에 기반이 되는 대규모의 GPU 인프라가 구축된 서버실 전경</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-12.jpg" />
          </div>
          <div class="txt">
            <p>정갈하게 정돈되어 서버실 랙에 연결되어 있는 케이블</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-13.jpg" />
          </div>
          <div class="txt">
            <p>서버실 랙을 통해 전원을 공급 받는 서버들</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-14.jpg" />
          </div>
          <div class="txt">
            <p>점검을 위한 cat walk 와 배선/배관들이 분리 구성되어 있는 서버실 상층부의 모습</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-15.jpg" />
          </div>
          <div class="txt">
            <p>에너지 효율을 높이는 저출력 대풍량의 바람을 서버실로 넣어주는 송풍기 팬</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-16.jpg" />
          </div>
          <div class="txt">
            <p>서버실 냉방을 위해 자연바람을 직/간접으로 활용하는 하이브리드 공조 시스템 NAMU lll</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-17.jpg" />
          </div>
          <div class="txt">
            <p>154kV 초고압의 전기를 안전하게 받아 각 세종 내에 전력을 공급해주는 GIS실</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-18.jpg" />
          </div>
          <div class="txt">
            <p>순간의 정전이 발생하더라도 서버에 안정적인 전원을 공급해주는 UPS</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-19.jpg" />
          </div>
          <div class="txt">
            <p>정전 발생 시 즉시 가동되어 최대 72시간까지 전원을 공급하는 비상발전기</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-20.jpg" />
          </div>
          <div class="txt">
            <p>화재 진압 시 필요한 소방 시스템 관련 설비가 구성된 소화가스실</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-21.jpg" />
          </div>
          <div class="txt">
            <p>대규모 데이터센터에 최적화된 구조와 규모로 설계된 기계실</p>
          </div>
        </div>
      </SliderTumbs>
      <article class="bottom">
        <GridBase b50>
          <TextBlock file="dc/sejong-data-t5" class="q pre-line" />
        </GridBase>
        <quick-link>
          <quick-link-item
            ><router-link to="gak-chuncheon"
              >GAK<br class="hidden-md-up" />
              Chuncheon</router-link
            ></quick-link-item
          >
          <quick-link-item type="gray"
            ><a class="launch" target="_blank" href="https://datacenter.ncloud.com/"
              >GAK<br class="hidden-md-up" />
              Chuncheon<br />Virtual tour</a
            ></quick-link-item
          >
        </quick-link>
      </article>
    </div>
  </GridBase>
</template>

<script>
import GridBase from "@/views/components/GridBase";
import PrSplit from "@/views/components/PrSplit";
import TextBlock from "@/views/components/TextBlock";
import PrHoldOrNot from "@/views/components/PrHoldOrNot";
import PrBlock from "@/views/components/PrBlock";
import feature from "@/data/gak/chuncheonFeature";
import QuickLink from "@/views/components/QuickLink";
import QuickLinkItem from "@/views/components/QuickLinkItem";
import Slider from "@/views/components/Slider";
import SliderTumbs from "@/views/components/SliderTumbs";
import PrSlideOrNot from "@/views/components/PrSlideOrNot";

import { getOffsetLeft } from "@/utils";

export default {
  name: "gak-common",
  components: {
    Slider,
    SliderTumbs,
    QuickLinkItem,
    QuickLink,
    PrBlock,
    PrHoldOrNot,
    TextBlock,
    PrSplit,
    GridBase,
    PrSlideOrNot,
  },
  data() {
    return {
      f2Active: -1,
      f3Active: -1,
      feature,
      f1: feature[0],
      f2: feature[1],
      f3: feature[2],
      buildingT1: `자연과<br />닮은 건물`,
      galleryT1: `데이터센터 각 세종<br /> 설계 3차 공모`,
    };
  },
  watch: {},
  computed: {
    chuncheonPopupStatus() {
      return this.$store.state.chuncheonPopup;
    },
  },
  methods: {
    showPopupF1(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-01",
        idx,
        info: this.f1,
      });
    },
    showPopupF2(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-02",
        idx,
        info: this.f2,
      });
    },
    resetF2(idx, el) {
      this.f2Active = idx;
      const right = getOffsetLeft(el) + +el.parentNode.style.transform.match(/(-?\d+)px/)[1] + el.offsetWidth;
      if (right > window.innerWidth) this.$refs.f2slide.next();
    },
    resetF3(idx) {
      if (this.sect === "sm" || this.sect === "md") {
        this.$store.commit("setChuncheonPopup", {
          type: "type-03",
          idx,
          info: this.f3,
        });
      } else {
        this.f3Active = this.f3Active === idx ? null : idx;
      }
    },
    closePopup() {
      this.$store.commit("setChuncheonPopup", null);
    },
    resize() {
      this.closePopup();
    },
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
};
</script>
